"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const _ = __importStar(require("lodash"));
function arrayEquals(a1, a2) {
    if (a1.length !== a2.length)
        return false;
    return a1.every((t, i) => t === a2[i]);
}
exports.arrayEquals = arrayEquals;
function cachedArrayMapper(keyF, createF, disposeF = (_) => { }) {
    let cachePrev = new Map();
    return function (tFrom) {
        const cacheCur = new Map();
        const output = tFrom.map((tFrom) => {
            const key = keyF(tFrom);
            const prev = cacheCur.get(key) || cachePrev.get(key);
            if (prev) {
                cacheCur.set(key, prev);
                return prev;
            }
            // else
            const tTo = createF(tFrom);
            cacheCur.set(key, tTo);
            return tTo;
        });
        // Clean up the difference
        const difference = _.difference(Array.from(cachePrev.values()), Array.from(cacheCur.values()));
        difference.forEach(i => disposeF(i));
        // Update the cache
        cachePrev = cacheCur;
        return output;
    };
}
exports.cachedArrayMapper = cachedArrayMapper;
function arraySubjectAdd(subject, t) {
    subject.next(_.concat(subject.value, t));
}
exports.arraySubjectAdd = arraySubjectAdd;
function arraySubjectRemove(subject, t) {
    subject.next(_.without(subject.value, t));
}
exports.arraySubjectRemove = arraySubjectRemove;
function added() {
    return source => source.pipe(operators_1.pairwise(), operators_1.map(([t0, t1]) => _.difference(t1, t0)));
}
exports.added = added;
function removed() {
    return source => source.pipe(operators_1.pairwise(), operators_1.map(([t0, t1]) => _.difference(t0, t1)));
}
exports.removed = removed;
function undiff(added$, removed$, seed = []) {
    const merged$ = rxjs_1.merge(added$.pipe(operators_1.map(t => [true, t])), removed$.pipe(operators_1.map(t => [false, t])));
    return merged$.pipe(operators_1.scan((acc, [op, t]) => op ? [...acc, ...t] : _.without(acc, ...t), seed));
}
exports.undiff = undiff;
function compareDefault(a, b) {
    function defined(x) {
        return x !== undefined;
    }
    if (!defined(a)) {
        if (!defined(b))
            return 0;
        return -1;
    }
    else {
        if (!defined(b))
            return 1;
        return a === b ? 0 : a < b ? -1 : 1;
    }
}
exports.compareDefault = compareDefault;
/**
 * Comparison function to use when sorting array of arrays.
 */
function compareArray(a, b, compareF = compareDefault) {
    const len = Math.max(a.length, b.length);
    for (let i = 0; i <= len; i++) {
        const A = a[i];
        const B = b[i];
        const c = compareF(A, B);
        if (c !== 0)
            return c;
    }
    return 0;
}
exports.compareArray = compareArray;
function sortingMap(comparatorF, compareF = (a, b) => (a - b)) {
    return (source) => {
        const source$ = source.pipe(operators_1.share()); // Turn into Hot so we can use it in takeUntil
        const sourceFinished$ = source$.pipe(operators_1.last(null, true));
        return source$.pipe(operators_1.switchMap((xs) => {
            // Convert each Array of elements into an Array of streams.
            // Each stream produces Pairs of <comparable, element> (as the comparable changes).
            const obs = xs.map((x) => {
                // Generate stream of comparables,
                // then pair the comparables with the original element
                return comparatorF(x).pipe(operators_1.map((comparator) => ({ comparator, x })));
            });
            // Because combineLatest([]) returns a "nothing" Observable
            // we have to handle it especially.
            if (obs.length === 0) {
                return rxjs_1.of([]);
            }
            else {
                // Combine to form a stream of Lists of Pairs of <comparable, element>, sorted
                return rxjs_1.combineLatest(obs).pipe(operators_1.takeUntil(sourceFinished$), // Stop when the original source finished
                operators_1.map((pairs) => [...pairs].sort((a, b) => compareF(a.comparator, b.comparator))), operators_1.map((pairs) => pairs.map((pair) => pair.x)));
            }
        }));
    };
}
exports.sortingMap = sortingMap;
// ------------------------------------------------------------
// mergingMap:
//
// Works like `mergeMap` but takes a function which can be used to produce extra
// output Observables, all of which will get merged together into one output.
// The inner function must produce at least one Observable.
function mergingMap(inner) {
    return operators_1.mergeMap((t) => {
        const outputs = [];
        outputs.push(inner(t, (output$) => outputs.push(output$)));
        return rxjs_1.merge(...outputs);
    });
}
exports.mergingMap = mergingMap;
function arrayMap(mapper) {
    return (source) => {
        const source$ = source.pipe(operators_1.share()); // Turn into Hot so we can use it in takeUntil
        const sourceFinished$ = source$.pipe(operators_1.last(null, true));
        return source$.pipe(operators_1.switchMap((xs) => {
            // Convert each Array of elements into an Array of streams.
            const obs$ = xs.map(mapper);
            // Because combineLatest([]) returns a "nothing" Observable
            // we have to handle it especially.
            if (obs$.length === 0) {
                return rxjs_1.of([]);
            }
            else {
                return rxjs_1.combineLatest(obs$).pipe(operators_1.takeUntil(sourceFinished$));
            }
        }));
    };
}
exports.arrayMap = arrayMap;
function arrayFilterMap(mapper) {
    return (source) => {
        return source.pipe(arrayMap(item => mapper(item).pipe(operators_1.map(b => [b, item]))), operators_1.map(tuples => {
            return tuples
                .filter(([b, _]) => b)
                .map(([_, item]) => item);
        }));
    };
}
exports.arrayFilterMap = arrayFilterMap;
